import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  /** Whether the sidebar drawer is currently visible */
  private _open = signal(false);
  readonly isOpen = this._open.asReadonly();

  toggle(): void {
    this._open.update((v) => !v);
  }

  open(): void {
    this._open.set(true);
  }

  close(): void {
    this._open.set(false);
  }
}
